$(function(){
  /*
  民間救急の求人を出す
  */
  if($('.js-employee_type').length) {
    // 読み込んだ時の処理
    $('.js-employee_type').hide();
    $('.js-employee_type input[type="radio"]').removeAttr("required");
  /*
  雇用形態で雇用期間の表示/非表示
  */
    // ページが読み込まれた時
     var employeeType = $('input[name=employee_type]:checked').val();
    if(employeeType == 2 || employeeType == 3 || employeeType == 4 ) {
      $('.js-employee_type').show();
      $('.js-employee_type input[type="radio"]').prop("required", true);
    }
    // 選択した時
    $(document).on('change', 'input[name="employee_type"]', function(){
      var val = $(this).val();
      if(val == 2 || val == 3 || val == 4) {
        $('.js-employee_type').fadeIn();
        $('.js-employee_type input[type="radio"]').prop("required", true);
      }else{
        $('.js-employee_type').fadeOut();
        $('.js-employee_type input[type="radio"]').removeAttr("required").prop("checked", false);
      }
    });
  }
});